import axios from "axios";
import querystring from "querystring";

import { API_HUBSPOT_URL } from "../../libs/constants";

import { getToken } from "../../libs/auth";

// ##############################
// Hubspot Information
// ##############################
export async function getCustomersFromHubspot(query) {
  return []
}

export async function getCustomerWithRobotIdFromHubspot(params, query) {
  const url = `${API_HUBSPOT_URL}/customers/${params}?${querystring.stringify(
    query
  )}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}

export async function getHubspotProperties(query) {
  const url = `${API_HUBSPOT_URL}/properties/?${querystring.stringify(query)}`;
  const options = {
    headers: { Authorization: `bearer ${getToken()}` },
    url,
  };
  try {
    const { data, status } = await axios(options);

    if (status === 200) {
      return data;
    } else {
      throw new Error(status);
    }
  } catch (err) {
    throw err;
  }
}
